import Swiper, { Lazy, Navigation, Pagination, Scrollbar } from 'swiper';
import 'swiper/css';
import 'swiper/css/lazy';

import 'swiper/css/navigation';
import 'swiper/css/pagination';
import EffectCoverflowTranslateX from './effect-coverflow-translate-x';

let currentSliderProducts = null;

function initializeSlider(containerId) {
    currentSliderProducts = initSliderProducts(containerId);

    if ($('.my-products').length > 0) {
        $('.select-my-products-categories').on('change', function () {
            $.get($(this).data('get') + '/' + $(this).val(), function (rs) {
                currentSliderProducts.destroy();

                $(containerId).find('.swiper-wrapper').html(rs);

                currentSliderProducts = initSliderProducts(containerId);
            });
        });
    }
}

function initSliderProducts(containerId) {
    const containerSlider = $(containerId);

    const swiperProducts = new Swiper(containerId + ' .swiper', {
        modules: [Navigation, Pagination, Scrollbar, Lazy, EffectCoverflowTranslateX],

        slidesPerView: 'auto',
        centeredSlides: true,
        centeredSlidesBounds: false,
        loop: $(containerId + ' .swiper .swiper-slide').length > 3,
        // initialSlide: 1,

        effect: 'coverflow-translate-x',
        coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 500,
            modifier: function (centerOffset) {
                return Math.round(centerOffset) == 0 ? 0 : 1;
            },
            slideShadows: false,
        },

        breakpoints: {
            0: {
                spaceBetween: 8,
                effect: 'slide',
                loop: false,
                scrollbar: {
                    dragSize: 20,
                },
            },
            //md
            768: {
                spaceBetween: 60,
            },
        },

        scrollbar: {
            el: containerId + ' .swiper-scrollbar',
            draggable: true,
            dragSize: 80,
        },

        lazy: {
            enabled: true,
            loadPrevNext: true,
            loadPrevNextAmount: 4,
        },

        navigation: {
            prevEl: containerId + ' .btn-prev',
            nextEl: containerId + ' .btn-next',
        },
        on: {
            afterInit: function () {
                const value = this.loopedSlides ? this.loopedSlides : this.slides.length;
                containerSlider.find('.slider-total-page').html(String(value).padStart(2, '0'));
                containerSlider.find('.slider-pager').toggleClass('hidden', value < 2);
            },
        },
    });

    updateProgress(containerSlider, swiperProducts.realIndex, swiperProducts.progress);
    swiperProducts.on('slideChange', function () {
        updateProgress(containerSlider, this.realIndex, this.progress);
    });

    return swiperProducts;
}

function updateProgress(container, realIndex, progress) {
    // container.find('.slider-current-page').html((realIndex + 1).toString().padStart(2, '0'));
    container.find('.slider-current-page').html('01');
    container.find('.slider-progress .progress-fill').css('width', Math.min(progress * 100, 100) + '%');
}

$('.slider-products').each(function () {
    initializeSlider('#' + $(this).attr('id'));
});
